import React from "react"
import { useTranslation } from "react-i18next"

import {
  type OperationalState,
  isUnscheduledFollowUp,
  overlayLabel,
  unscheduledFollowUpColor,
  operationalStateColorMap
} from "../../Lead/constants/operational-states.ts"
import { LeadPill } from "./LeadPill.tsx"

interface LeadOverlayPillProps
  extends Omit<React.ComponentProps<typeof LeadPill>, "children" | "style"> {
  state: OperationalState
  followUpDate?: string | null
}

/** The ref is forwarded because the header hands a pill to a Popover trigger. */
export const LeadOverlayPill = React.forwardRef<
  HTMLSpanElement,
  LeadOverlayPillProps
>(({ state, followUpDate, ...rest }, ref) => {
  const { t } = useTranslation()
  const unscheduled = isUnscheduledFollowUp(state, followUpDate)

  return (
    <LeadPill
      ref={ref}
      style={
        unscheduled ? unscheduledFollowUpColor : operationalStateColorMap[state]
      }
      {...rest}
    >
      {overlayLabel(state, followUpDate, t)}
    </LeadPill>
  )
})

LeadOverlayPill.displayName = "LeadOverlayPill"
